import MessageBroker from './message-broker'

export default new MessageBroker()
